import React from 'react';

import { t } from '@sm/intl';
import { Grid } from '@wds/grid';
import { Box } from '@wds/box';

import MainHeading from '~pricing/components/MainHeading';
import Navigation from '~pricing/components/Navigation';
import HubSpotForm from '~pricing/components/HubSpotForm';

import COPY from './copy';
import ContactUs from './ContactUs';

import useEnterprisePageStyles from './useStyles';

export default function EnterprisePage(): JSX.Element {
  const { HubSpotWrapper } = useEnterprisePageStyles();
  return (
    <>
      <header>
        <MainHeading>{t(COPY.MAIN_HEADING)}</MainHeading>
        <Navigation />
      </header>
      <Box display="flex" flexJustify="center">
        <Grid pt={4} pb={5}>
          <Grid.Item xs={12} md={6} lg={6}>
            <ContactUs />
          </Grid.Item>
          <Grid.Item xs={12} md={5} lg={5}>
            <Box className={HubSpotWrapper} p={4}>
              <HubSpotForm />
            </Box>
          </Grid.Item>
        </Grid>
      </Box>
    </>
  );
}
